import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
	<App dataUrl={document.getElementById('app-portfolio').getAttribute('data-url')}/>,
	document.getElementById('app-portfolio')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js